import React from "react";
import styles from "../../../CSS/sections/HomeBanner.module.css";
// import Button from "/components/new_redesign_components/ui/Button";
import { ArrowRight, Mouse, Play } from "lucide-react";
import Button from "../ui/Button";

const HomeBanner = ({ content }) => {
  const { title, description, ctas, stats, shortDescription } = content;
  return (
    <section className={`${styles.heroSection} padding-y`}>
      <div className="container">
        <div className="row">
          <div className="col-12 col-lg-11 offset-lg-1 text-center">
            <div className={styles.heroContent}>
              <h1 className="text-light mb-4 heading1">{title}</h1>
              <p className="text-light" style={{ marginBottom: "36px" }}>
                {description}
              </p>

              <div className={`${styles.rowCustom} row g-3 g-lg-5 mb-4 mb-lg-5`}>
                {stats.map((stat, idx) => (
                  <div className="col-12 col-sm-6 col-lg-3" key={idx}>
                    <div className={styles.statCard}>
                      <h3 className={`${styles.statCardTitle} heading2 mb-1`}>
                        {stat.value}
                      </h3>
                      <p className="p15 text-light mb-0">{stat.label}</p>
                    </div>
                  </div>
                ))}
              </div>

              <p className="text-light  mb-4 mb-lg-5" >
                {shortDescription}
              </p>

              <div
                className="d-flex flex-wrap justify-content-center"
                style={{ gap: "30px" }}
              >
                {ctas.map((cta, idx) => {
                  const isLight = cta.variant === "light";
                  const isOutlineLight = cta.variant === "outline-light";
                  return (
                    <Button
                      key={idx}
                      url={cta.href}
                      label={cta.text}
                      variant={isOutlineLight ? "outline" : "solid"}
                      // Use built-in defaults; override via props if needed
                      // bgColor={isLight ? "rgba(255,255,255,0.8)" : undefined}
                      textColor={isOutlineLight ? "#fff" : undefined}
                      leftIcon={isOutlineLight ? Play : undefined}
                      rightIcon={isLight ? ArrowRight : undefined}
                      className="" // spacing handled by component CSS
                      target={cta?.target}
                    />
                  );
                })}
              </div>
              <div className="mt-5">
                <Mouse size={42} strokeWidth={2} color="gray" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeBanner;